export default __webpack_public_path__ + "static/media/lichen-planus-pigmentosusp.617537ab.pdf";